import { ControlledSelect } from 'components/shared/ControlledFields';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useGetCostCenterDutyHourTypeList } from '../hooks/useGetCostCenterDutyHourTypeList';

const importTypeOpts = [
  {
    value: 'SDB',
    label: 'SDB'
  },
  {
    value: 'AFAS',
    label: 'AFAS'
  }
];

export const FormContent = () => {
  'use memo';

  const { control } = useFormContext();
  const { t } = useTranslation('common', {
    keyPrefix: 'importAbsenceSettings'
  });
  const data = useGetCostCenterDutyHourTypeList();

  const dutyHourTypeOpts = data?.map((item) => ({
    value: item.id,
    label: item.description
  }));

  return (
    <>
      <ControlledSelect
        options={importTypeOpts}
        name="import_absence_type"
        label={t('importType')}
        control={control}
      />
      <ControlledSelect
        name="import_absence_dutyHourTypeId"
        control={control}
        label={t('dutyHourType')}
        options={dutyHourTypeOpts ?? []}
      />
      <ControlledSelect
        name="import_absence_dutyHourTypeIdPregnancy"
        label={t('pregnancyDutyHourType')}
        control={control}
        options={dutyHourTypeOpts ?? []}
      />
    </>
  );
};
